import { apiUrl } from '../content/landingContent.js'

// Cadastro pago via Pix (Mercado Pago). Espelha o fluxo Stripe do
// TenantSignupModal, mas em vez de um Payment Element com redirect, gera uma
// cobrança Pix e o modal faz polling até o pagamento confirmar.

// Cria a cobrança Pix do cadastro. `form` tem os mesmos campos do checkout
// Stripe. Retorna { ok, qr_code, qr_code_base64, ticket_url, expires_at,
// external_reference, error }.
export async function startPixSignup(form) {
  try {
    const res = await fetch(`${apiUrl}/api/public/tenants/pix-checkout-session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: form.name,
        document: form.document,
        address: form.address,
        address_number: form.address_number,
        neighborhood: form.neighborhood,
        city: form.city,
        state: form.state,
        zip_code: form.zip_code,
        establishment_name: form.establishment_name,
        admin_name: form.admin_name,
        admin_email: form.admin_email,
        admin_password: form.admin_password,
        plan_id: form.plan_id,
        billing_cycle: form.billing_cycle,
        terms_accepted: form.terms_accepted,
      }),
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) return { ok: false, error: data.error || 'Não foi possível gerar o Pix. Tente novamente.' }
    return { ok: true, ...data }
  } catch {
    return { ok: false, error: 'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.' }
  }
}

// Consulta o status da cobrança Pix do cadastro.
//   'pending'   — ainda não pago
//   'completed' — conta criada (ou já existia)
//   'failed'    — não foi possível criar a conta (suporte)
export async function pollPixSignup(externalReference) {
  try {
    const res = await fetch(
      `${apiUrl}/api/public/tenants/pix-signup-status?ref=${encodeURIComponent(externalReference)}`
    )
    const data = await res.json().catch(() => ({}))
    if (!res.ok) return { status: 'pending' }
    return { status: data.status || 'pending' }
  } catch {
    return { status: 'pending' }
  }
}
